import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { MetaPixelProvider } from './components/MetaPixel';
export function AppRouter() {
  return <MetaPixelProvider data-id="element-15">
      <BrowserRouter data-id="element-16">
        <Routes data-id="element-17">
          <Route path="/" element={<App data-id="element-19" />} data-id="element-18" />
        </Routes>
      </BrowserRouter>
    </MetaPixelProvider>;
}